import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { settingsPagePermission } from "@redotech/redo-merchant-app-common/routing/settings-page-permission";

export const customerAccountSettingsRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      get breadcrumb() {
        return t("Ad blocks", {
          context:
            "merchant settings label for customer account advertisements",
        });
      },
      permission: settingsPagePermission("customer-accounts/ad-blocks"),
    },
    path: "customer-accounts-ad-blocks",
    children: [
      {
        index: true,
        lazy: async () => {
          const { AdBlocksPage } =
            await import("../../../../setting/customer-accounts/ad-blocks/ad-blocks-drawer");
          return { Component: AdBlocksPage };
        },
      },
      {
        path: ":adBlockId",
        handle: {
          get breadcrumb() {
            return t("Edit Ad Block");
          },
        },
        lazy: async () => {
          const { AdBlockBuilder } =
            await import("../../../../setting/customer-accounts/ad-blocks/ad-blocks-builder");
          return { element: <AdBlockBuilder /> };
        },
      },
    ],
  },
  {
    handle: {
      get breadcrumb() {
        return t("Storefront display", {
          context:
            "merchant settings label for customer account storefront displays",
        });
      },
      permission: settingsPagePermission(
        "customer-accounts/storefront-display",
      ),
    },
    path: "customer-accounts-storefront-display",
    lazy: async () => {
      const { StorefrontDisplaysPage } =
        await import("../../../../setting/customer-accounts/storefront-displays");
      return { Component: StorefrontDisplaysPage };
    },
  },
];
